import { IAvailableHours } from './available-hours';

export interface ICustomerContact {
  id: number;
  firstName: string | null;
  lastName: string | null;
  jobTitle?: string;
  email: string;
  phoneNumber: string;
  availableHours?: IAvailableHours;
  comment?: string;
}

export function NewCustomerContact(): ICustomerContact {
  return {
    id: 0,
    firstName: null,
    lastName: null,
    jobTitle: '',
    email: '',
    phoneNumber: '',
    availableHours: { daysOfWeek: [], from: 0, to: 0 },
    comment: '',
  }
}
